"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _zod = require("zod");

var _widgetContainer = require("../widget-container");

var widgetName = 'third_party_widget';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-third_party_widget';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  title: _zod.z.string(),
  subtitle: _zod.z.string(),
  transpiledCode: _zod.z.string().optional()
});

exports.config = config;

var ThirdPartyHTML = function ThirdPartyHTML(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      _ref$transpiledCode = _ref.transpiledCode,
      transpiledCode = _ref$transpiledCode === void 0 ? '' : _ref$transpiledCode;
  return (0, _preact.h)("div", {
    className: "custom-html-widget-wrapper"
  }, title ? (0, _preact.h)("div", {
    className: "sitewidth"
  }, (0, _preact.h)("div", {
    className: "col"
  }, (0, _preact.h)(_widgetContainer.WidgetTitle, {
    content: title
  }), (0, _preact.h)(_widgetContainer.WidgetSubtitle, {
    content: subtitle,
    hasWidgetTitle: Boolean(title)
  }))) : null, (0, _preact.h)("section", {
    className: "full-width custom-html",
    dangerouslySetInnerHTML: {
      __html: transpiledCode
    }
  }));
};

var _default = ThirdPartyHTML;
exports.default = _default;